const TECHNICAL_EVENTS = new Set([
  "next-cycle-number",
  "pusher:connection_established",
  "pusher:subscription_succeeded",
  "pusher_internal:subscription_succeeded",
]);

const ENTITY_LABELS = {
  planned_cycle: "zaplanowany cykl",
  task: "zadanie",
  assortment: "asortyment",
  freeze_dryer: "liofilizator",
  sheet: "arkusz",
};

function entityLabel(entity = "") {
  if (ENTITY_LABELS[entity]) return ENTITY_LABELS[entity];
  if (entity.startsWith("warehouse_")) return "pozycję magazynową";
  if (entity.startsWith("catalog_")) return "pozycję słownika";
  if (entity.includes("meal") || entity.includes("dish")) return "dane planowania dań";
  return "dane";
}

function actionMessage(action, label) {
  if (action === "created") return `Dodano ${label}.`;
  if (action === "deleted") return `Usunięto ${label}.`;
  return `Zaktualizowano ${label}.`;
}

export function createRealtimeToastNotifier({ notify, maxEventIds = 500 }) {
  const seenEventIds = new Set();
  let previousState = "idle";

  function remember(eventId) {
    if (!eventId) return true;
    if (seenEventIds.has(eventId)) return false;
    seenEventIds.add(eventId);
    if (seenEventIds.size > maxEventIds) {
      seenEventIds.delete(seenEventIds.values().next().value);
    }
    return true;
  }

  return {
    onState(state) {
      if (state === "connected" && previousState !== "connected") {
        notify({
          severity: "success",
          summary: "Połączenie realtime aktywne",
          detail: "Automatyczne odświeżanie danych działa.",
          life: 3000,
        });
      }
      previousState = state;
    },
    onEvent(eventName, payload = {}) {
      if (
        !eventName ||
        eventName.startsWith("pusher:") ||
        eventName.startsWith("pusher_internal:") ||
        TECHNICAL_EVENTS.has(eventName) ||
        !remember(payload.event_id)
      ) return;

      notify({
        severity: "info",
        summary: "Aktualizacja realtime",
        detail: actionMessage(payload.action, entityLabel(payload.entity)),
        life: 3500,
      });
    },
  };
}
